module.exports = __webpack_public_path__ + "static/img/home-banner.46c06a53.jpg";